export default __webpack_public_path__ + "Mask-group-7.a8f7cc.svg";